import React from "react";
import NavbarComp from '../components/NavbarComp';
import FooterComp from '../components/FooterComp';

export default function NotFound() {
  return (<> <NavbarComp />
    <div className="forbidden-container">
      <h1>Thanks for visiting</h1>
      <p>This page is for invited users only. Please contact your line manager to request access and take part in our research.</p>
    </div>
    <FooterComp />
  </>);
}